import { useCallback } from 'react';

import { type Board } from '@air/api/types';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackExpandNestedContent.meta';

export type TrackExpandNestedContentParams = {
  action: 'expand' | 'collapse';
  board_id?: Board['id'];
};

export const useTrackExpandNestedContent = () => {
  const { track } = useAnalyticsUtilities();

  const trackExpandNestedContent = useCallback(
    (params: TrackExpandNestedContentParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackExpandNestedContent };
};
